import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../context/UserContext";
import AdminNav from "../../../components/AdminNav/AdminNav";

import "./Adminpostcontrol.css";

export default function Adminpostcontrol() {
  const navigate = useNavigate();
  const { user } = useUser();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [publishDate, setPublishDate] = useState("");
  const [publishTime, setPublishTime] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;
  const storageUrl = process.env.REACT_APP_STORAGE_URL;

  const handleDelete = async (postId) => {
    if (!window.confirm("Biztosan törölni szeretnéd ezt a bejegyzést?")) return;
    const token = localStorage.getItem("token");
    try {
      await fetch(`${apiUrl}/posts/${postId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        credentials: "include",
      });
      // Refresh posts
      setLoading(true);
      fetch(`${apiUrl}/posts/all-status`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => {
          setPosts(data);
          setLoading(false);
        });
    } catch (err) {
  alert("A bejegyzés törlése nem sikerült.");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`${apiUrl}/posts/all-status`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setPosts(Array.isArray(data) ? data : []);
        setLoading(false);
      });
  }, [apiUrl]);

   // Unpublish post handler
  const handleUnpublish = async (postId) => {
    const token = localStorage.getItem("token");
    await fetch(`${apiUrl}/posts/${postId}/publish`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ published_at: null }),
    });
    // Refresh posts
    setLoading(true);
    fetch(`${apiUrl}/posts/all-status`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setPosts(data);
        setLoading(false);
      });
  };

  const openModal = (id) => {
    setSelectedPostId(id);
    setPublishDate("");
    setPublishTime("");
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedPostId(null);
    setPublishDate("");
    setPublishTime("");
  };

  const handlePublish = async () => {
    if (!publishDate || !publishTime) {
      alert("Kérlek, válassz ki dátumot és időpontot is!");
      return;
    }
    const token = localStorage.getItem("token");
    const dateTime = `${publishDate}T${publishTime}:00`;
    await fetch(`${apiUrl}/posts/${selectedPostId}/publish`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ published_at: dateTime }),
    });
    // Refresh posts
    setLoading(true);
    fetch(`${apiUrl}/posts/all-status`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setPosts(data);
        setLoading(false);
        closeModal();
      });
  };

  const formatDate = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    const pad = (n) => n.toString().padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  return (
    <div>
      <AdminNav />
      <div className="admin-container">
        <h2>Bejegyzések kezelése</h2>
        {loading ? (
          <div>Betöltés...</div>
        ) : (
          <>
            <table className="admin-post-table">
              <thead>
                <tr>
                  <th>Borítókép</th>
                  <th>Cím</th>
                  <th>Megtekintés</th>
                  <th>Státusz</th>
                  {user && user.is_admin ? <th>Publikálás</th> : <th></th>}
                  {user && user.is_admin ? <th>Szerkesztés</th> : <th></th>}
                  {user && user.is_admin ? <th>Törlés</th> : <th></th>}
                </tr>
              </thead>
              <tbody>
                {posts.map((post) => (
                  <tr key={post.id}>
                    <td className="thumbnail-cell">
                      {post.thumbnail ? (
                        <img src={`${storageUrl}${post.thumbnail}`} alt={`Borítókép - ${post.title}`} className="post-thumbnail" />
                      ) : (
                        <div className="thumbnail-placeholder" aria-hidden="true"></div>
                      )}
                    </td>
                    <td>
                      <div className="post-title-with-inline">
                        {post.thumbnail ? (
                          <img src={`${storageUrl}${post.thumbnail}`} alt={`Borítókép - ${post.title}`} className="post-thumbnail-inline" />
                        ) : (
                          <div className="thumbnail-inline-placeholder" aria-hidden="true"></div>
                        )}
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                          <a href={`/article/${post.slug}`} target="_blank" rel="noopener noreferrer" className="admin-post-link">
                            {post.title}
                          </a>
                        </div>
                      </div>
                    </td>
                    <td className="views-cell">{typeof post.views === 'number' ? <><span className="views-label">Megtekintések száma:&nbsp;</span><span>{post.views}</span></> : 0}</td>
                    <td>
                      {post.published ? (
                        new Date(post.published_at) > new Date()
                          ? `Ütemezve: ${formatDate(post.published_at)}`
                          : `Publikálva (${formatDate(post.published_at)})`
                      ) : (
                        // If the post is not published, show an Edit button for non-admin users so they can start editing
                        user && !user.is_admin ? (
                          <button
                            onClick={() => navigate(`/admin/edit/${post.slug}`)}
                            className="edit-btn"
                          >
                            Szerkesztés
                          </button>
                        ) : (
                          // For admins or anonymous viewers, keep the existing label
                          "Nincs publikálva"
                        )
                      )}
                    </td>
                    {user && user.is_admin ? (
                      <>
                        <td>
                          {!post.published ? (
                            <button
                              onClick={() => openModal(post.id)}
                              className="publish-btn"
                            >
                              Publikálás
                            </button>
                          ) : (
                            <button
                              onClick={() => handleUnpublish(post.id)}
                              className="unpublish-btn"
                            >
                              Publikálás visszavonása
                            </button>
                          )}
                        </td>
                        <td>
                          <button
                            onClick={() => navigate(`/admin/edit/${post.slug}`)}
                            className="edit-btn"
                          >
                            Szerkesztés
                          </button>
                        </td>
                        <td>
                          <button
                            onClick={() => handleDelete(post.id)}
                            className="delete-btn"
                          >
                            Törlés
                          </button>
                        </td>
                      </>
                    ) : (
                      <>
                        <td></td>
                        <td></td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            {showModal && (
              <div className={`modal-overlay ${showModal ? 'active' : ''}`}>
                <div className="modal">

                  <h3 className="modal-title">
                    <span role="img" aria-label="calendar" className="modal-icon">📅</span>
                    Válassz publikálási dátumot és időpontot
                  </h3>
                  <input
                    type="date"
                    value={publishDate}
                    onChange={(e) => setPublishDate(e.target.value)}
                    className="modal-input"
                  />
                  <input
                    type="time"
                    value={publishTime}
                    onChange={(e) => setPublishTime(e.target.value)}
                    className="modal-input"
                  />
                  <div className="modal-actions">
                    <button
                      onClick={handlePublish}
                      className="publish-btn"
                    >
                      Publikálás
                    </button>
                    <button
                      onClick={closeModal}
                      className="cancel-btn"
                    >
                      Mégse
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

